module.exports = __webpack_public_path__ + "static/media/centric.bf52e018.jpg";